(() => {
  document.querySelectorAll('[data-llt]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    const locale = root.dataset.locale || 'de';
    const isRtl = root.getAttribute('dir') === 'rtl';
    let idempotencyKey = crypto.randomUUID();

    root.querySelectorAll('[data-llt-scroll]').forEach(button => {
      button.addEventListener('click', () => {
        const target = document.getElementById(button.dataset.lltScroll);
        if (!target) return;
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        target.querySelector('input,select,button')?.focus({ preventScroll: true });
      });
    });

    const gallery = root.querySelector('[data-llt-gallery]');
    if (gallery) {
      const slides = [...gallery.querySelectorAll('[data-llt-slide]')];
      const dots = [...gallery.querySelectorAll('[data-llt-dot]')];
      const status = gallery.querySelector('[data-llt-gallery-status]');
      let current = 0;
      let timer;
      let touchStartX = 0;
      const activeTabIndex = index => index === current ? '0' : '-1';
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        dots.forEach((dot, i) => {
          dot.setAttribute('aria-selected', String(i === current));
          dot.setAttribute('tabindex', activeTabIndex(i));
        });
        if (status) status.textContent = dots[current]?.getAttribute('aria-label') || '';
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => show(current + 1), 5000);
      };
      gallery.setAttribute('tabindex', '0');
      gallery.querySelectorAll('img').forEach(image => image.addEventListener('error', () => {
        image.closest('[data-llt-slide]')?.classList.add('has-image-error');
        image.hidden = true;
      }, { once: true }));
      gallery.querySelector('[data-llt-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
      gallery.querySelector('[data-llt-next]')?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
      gallery.addEventListener('mouseenter', stop);
      gallery.addEventListener('mouseleave', start);
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) start(); });
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') show(0);
        else if (event.key === 'End') show(slides.length - 1);
        else if (event.key === 'ArrowLeft') show(current + (isRtl ? 1 : -1));
        else show(current + (isRtl ? -1 : 1));
        start();
      });
      gallery.addEventListener('touchstart', event => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stop();
      }, { passive: true });
      gallery.addEventListener('touchend', event => {
        const delta = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(delta) > 45) show(current + (delta > 0 ? (isRtl ? 1 : -1) : (isRtl ? -1 : 1)));
        start();
      }, { passive: true });
      show(0);
      start();
    }

    const modal = root.querySelector('[data-llt-modal]');
    const modalDialog = modal?.querySelector('[role="dialog"]');
    const modalContent = modal?.querySelector('[data-llt-modal-content]');
    const modalTitle = modal?.querySelector('[data-llt-modal-title]');
    let mediaTrigger = null;
    const safeUrl = value => {
      if (typeof value !== 'string' || !value.trim()) return null;
      try {
        const url = new URL(value, window.location.origin);
        return url.protocol === 'https:' || (url.origin === window.location.origin && url.protocol === window.location.protocol) ? url : null;
      } catch {
        return null;
      }
    };
    const safeEmbed = value => {
      const url = safeUrl(value);
      return url && ['www.youtube.com', 'www.youtube-nocookie.com', 'player.vimeo.com'].includes(url.hostname) ? url : null;
    };
    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      modalContent.replaceChildren();
      document.documentElement.style.overflow = '';
      mediaTrigger?.focus();
    };
    modal?.querySelectorAll('[data-llt-close]').forEach(button => button.addEventListener('click', closeModal));
    const openMedia = (record, trigger, title) => {
      if (!modal || !modalContent || !modalTitle) return;
      const videoUrl = safeUrl(record.videoUrl);
      const embedUrl = safeEmbed(record.embedUrl);
      if (!videoUrl && !embedUrl) return;
      const media = videoUrl ? document.createElement('video') : document.createElement('iframe');
      if (videoUrl) {
        media.src = videoUrl.href;
        media.controls = true;
        media.playsInline = true;
        media.preload = 'metadata';
      } else {
        media.src = embedUrl.href;
        media.title = title;
        media.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation');
        media.setAttribute('allow', 'fullscreen; picture-in-picture');
        media.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      }
      mediaTrigger = trigger;
      modalTitle.textContent = title;
      modalContent.replaceChildren(media);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      modalDialog?.focus();
    };
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeModal();
      if (event.key === 'Tab' && modal && !modal.hidden) {
        const focusable = [...modal.querySelectorAll('button,video,iframe,[tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    const loadMedia = async () => {
      if (!root.dataset.mediaUrl) return;
      try {
        const response = await fetch(root.dataset.mediaUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const body = await response.json();
        const records = Array.isArray(body) ? body : Array.isArray(body?.records) ? body.records : Array.isArray(body?.media) ? body.media : [];
        records.forEach(record => {
          const position = Number(record?.position);
          if (!Number.isInteger(position) || position < 1 || position > 4) return;
          const imageUrl = safeUrl(record.imageUrl);
          const alt = typeof record.alt === 'string' && record.alt.trim() ? record.alt.trim() : '';
          const slideImage = root.querySelector(`[data-llt-slide][data-position="${position}"] img`);
          const card = root.querySelector(`[data-llt-media-card][data-position="${position}"]`);
          const cardImage = card?.querySelector('img');
          if (imageUrl) {
            if (slideImage && !slideImage.hasAttribute('data-real-hero')) slideImage.src = imageUrl.href;
            if (cardImage && !cardImage.closest('[data-real-tour-poster]')) cardImage.src = imageUrl.href;
          }
          if (alt) {
            if (slideImage && !slideImage.hasAttribute('data-real-hero')) slideImage.alt = alt;
            if (cardImage && !cardImage.closest('[data-real-tour-poster]')) cardImage.alt = alt;
          }
          const play = card?.querySelector('[data-llt-play]');
          if (play && (safeUrl(record.videoUrl) || safeEmbed(record.embedUrl))) {
            play.hidden = false;
            play.addEventListener('click', () => openMedia(record, play, alt || card.querySelector('h3')?.textContent || root.dataset.playLabel));
          }
        });
      } catch {
        // Static approved posters and copy remain the truthful fallback.
      }
    };
    loadMedia();

    if (root.dataset.dataCollectionApproved !== 'true') return;
    const form = root.querySelector('[data-llt-form]');
    const success = root.querySelector('[data-llt-success]');
    const errorContainer = root.querySelector('[data-llt-error]');
    if (!form || !success || !errorContainer) return;

    const steps = [...form.querySelectorAll('[data-llt-step]')];
    const nextButton = form.querySelector('[data-llt-next]');
    const backButton = form.querySelector('[data-llt-back]');
    const submitButton = form.querySelector('[data-llt-submit]');
    const progressText = form.querySelector('[data-llt-progress-text]');
    const progressBar = form.querySelector('[data-llt-progress-bar]');
    const dateInput = form.elements.namedItem('date');
    const slotsContainer = form.querySelector('[data-llt-slots]');
    const slotsStatus = form.querySelector('[data-llt-slots-status]');
    const preferenceFields = form.querySelector('[data-llt-preference-fields]');
    const manualChoice = form.querySelector('input[name="scheduleChoice"][value="preference"]');
    const slotRecords = new Map();
    let step = 0;

    const zurichToday = () => {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const value = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return `${value.year}-${value.month}-${value.day}`;
    };
    if (dateInput instanceof HTMLInputElement) {
      dateInput.min = zurichToday();
      if (!dateInput.value) dateInput.value = zurichToday();
    }
    const timeInput = form.elements.namedItem('startTime');
    if (timeInput instanceof HTMLInputElement && !timeInput.value) {
      timeInput.value = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date());
    }
    const setError = message => {
      errorContainer.textContent = message;
      errorContainer.hidden = false;
      errorContainer.focus();
    };
    const clearError = () => {
      errorContainer.hidden = true;
      errorContainer.textContent = '';
    };
    const fieldValue = name => {
      const field = form.elements.namedItem(name);
      return field instanceof HTMLInputElement || field instanceof HTMLSelectElement ? field.value.trim() : '';
    };
    const selectedSlotId = () => {
      const choice = form.querySelector('input[name="scheduleChoice"]:checked')?.value || '';
      return choice.startsWith('slot:') ? choice.slice(5) : '';
    };
    const preferenceSelected = () => form.querySelector('input[name="scheduleChoice"]:checked')?.value === 'preference';
    const updateScheduleMode = () => {
      const preference = preferenceSelected();
      preferenceFields?.querySelectorAll('input').forEach(input => {
        input.disabled = !preference;
      });
    };
    const activateManualFallback = () => {
      if (manualChoice instanceof HTMLInputElement) manualChoice.checked = true;
      updateScheduleMode();
    };
    const validateFields = fields => {
      const invalid = fields.find(field => typeof field.checkValidity === 'function' && !field.checkValidity());
      if (!invalid) return true;
      invalid.reportValidity();
      invalid.focus();
      return false;
    };
    const zurichDateTimeParts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const resolveZurichWallTime = (date, time) => {
      const base = Date.parse(`${date}T${time}:00Z`);
      if (!Number.isFinite(base)) return [];
      const matches = [];
      for (let offsetMinutes = -180; offsetMinutes <= 180; offsetMinutes += 15) {
        const candidate = new Date(base + offsetMinutes * 60000);
        const parts = Object.fromEntries(zurichDateTimeParts.formatToParts(candidate).map(part => [part.type, part.value]));
        if (`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}` === `${date}T${time}`) matches.push(candidate);
      }
      return matches;
    };
    const windowIsValid = () => {
      const date = fieldValue('date');
      const start = fieldValue('startTime');
      if (!date || date < zurichToday() || !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(start)) return false;
      const starts = resolveZurichWallTime(date, start);
      return starts.length === 1;
    };
    const scheduleIsValid = () => preferenceSelected()
      ? windowIsValid()
      : Boolean(selectedSlotId() && slotRecords.has(selectedSlotId()));
    const updateSummary = () => {
      form.querySelector('[data-llt-summary="topic"]').textContent = fieldValue('topic');
      form.querySelector('[data-llt-summary="name"]').textContent = fieldValue('name');
      form.querySelector('[data-llt-summary="email"]').textContent = fieldValue('email');
      const selected = slotRecords.get(selectedSlotId());
      form.querySelector('[data-llt-summary="window"]').textContent = selected?.label || `${fieldValue('date')} · ${fieldValue('startTime')} · Europe/Zurich`;
    };
    const showStep = (index, focusField = true) => {
      step = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((fieldSet, i) => { fieldSet.hidden = i !== step; });
      backButton.hidden = step === 0;
      nextButton.hidden = step === steps.length - 1;
      submitButton.hidden = step !== steps.length - 1;
      progressText.textContent = `${root.dataset.stepLabel} ${step + 1} ${root.dataset.ofLabel} ${steps.length}`;
      progressBar.style.width = `${((step + 1) / steps.length) * 100}%`;
      clearError();
      if (step === steps.length - 1) updateSummary();
      if (focusField) steps[step].querySelector('input,select')?.focus();
    };

    const loadSlots = async () => {
      if (!root.dataset.slotsUrl || !slotsContainer || !slotsStatus) return;
      try {
        const response = await fetch(root.dataset.slotsUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error();
        const body = await response.json();
        const slots = Array.isArray(body) ? body : Array.isArray(body?.slots) ? body.slots : Array.isArray(body?.records) ? body.records : [];
        slots.forEach(slot => {
          const id = typeof slot?.id === 'string' ? slot.id.trim() : '';
          const startAt = new Date(slot?.startAt);
          const endAt = new Date(slot?.endAt);
          const timezone = slot?.timezone === 'Europe/Zurich' ? slot.timezone : '';
          if (!id || !timezone || !Number.isFinite(startAt.getTime()) || !Number.isFinite(endAt.getTime()) || startAt <= new Date() || endAt <= startAt) return;
          const dateFormatter = new Intl.DateTimeFormat(locale, { timeZone: timezone, weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
          const timeFormatter = new Intl.DateTimeFormat(locale, { timeZone: timezone, hour: '2-digit', minute: '2-digit' });
          const label = `${dateFormatter.format(startAt)} · ${timeFormatter.format(startAt)}–${timeFormatter.format(endAt)} · ${timezone}`;
          slotRecords.set(id, { id, label });
          const option = document.createElement('label');
          option.className = 'llt-slot';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'scheduleChoice';
          radio.value = `slot:${id}`;
          const text = document.createElement('span');
          text.textContent = label;
          option.append(radio, text);
          slotsContainer.append(option);
        });
      } catch {
        slotRecords.clear();
      }
      if (!slotRecords.size) activateManualFallback();
      slotsStatus.textContent = slotRecords.size ? '' : root.dataset.slotsNone;
      slotsStatus.hidden = slotRecords.size > 0;
    };
    loadSlots();
    form.addEventListener('change', event => {
      if (event.target instanceof HTMLInputElement && event.target.name === 'scheduleChoice') updateScheduleMode();
    });
    updateScheduleMode();

    nextButton.addEventListener('click', () => {
      if (!validateFields([...steps[step].querySelectorAll('input,select')])) return;
      if (step === 1 && !scheduleIsValid()) {
        setError(root.dataset.errTime);
        return;
      }
      showStep(step + 1);
    });
    backButton.addEventListener('click', () => showStep(step - 1));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      clearError();
      if (!validateFields([...form.querySelectorAll('input,select')])) {
        setError(root.dataset.errValidation);
        return;
      }
      if (!scheduleIsValid()) {
        showStep(1);
        setError(root.dataset.errTime);
        return;
      }
      submitButton.disabled = true;
      submitButton.textContent = root.dataset.sending;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      const phone = fieldValue('phone');
      const slotId = selectedSlotId();
      try {
        const response = await fetch(root.dataset.proxyUrl, {
          method: 'POST',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
          body: JSON.stringify({
            topic: fieldValue('topic'),
            ...(slotId ? { slotId, preferredWindows: [] } : {
              preferredWindows: [{ date: fieldValue('date'), startTime: fieldValue('startTime') }]
            }),
            contact: { name: fieldValue('name'), email: fieldValue('email'), ...(phone ? { phone } : {}) },
            locale,
            consented: false,
            consentPurpose: 'appointment_contact',
            consentVersion: root.dataset.consentVersion
          })
        });
        if (!response.ok) {
          const requestError = new Error('HTTP');
          requestError.status = response.status;
          throw requestError;
        }
        const data = await response.json();
        const validResponse = /^[0-9a-f-]{36}$/i.test(data?.id || '') && data.status === 'requested' && data.timezone === 'Europe/Zurich' && Number.isInteger(data.version) && data.version >= 1;
        if (!validResponse) {
          const requestError = new Error('CONTRACT');
          requestError.contract = true;
          throw requestError;
        }
        success.querySelector('[data-llt-reference]').textContent = data.id;
        form.hidden = true;
        success.hidden = false;
        success.focus();
        form.reset();
        idempotencyKey = crypto.randomUUID();
      } catch (error) {
        const message = error.name === 'AbortError' ? root.dataset.errTimeout
          : error.contract ? root.dataset.errContract
            : error.status === 409 ? root.dataset.errConflict
              : error.status === 503 ? root.dataset.errUnavailable
                : !navigator.onLine || error instanceof TypeError ? root.dataset.errNetwork : root.dataset.errApi;
        setError(message);
        submitButton.disabled = false;
        submitButton.textContent = root.dataset.submitLabel;
      } finally {
        window.clearTimeout(timeout);
      }
    });
    // Initial rendering must not steal focus or scroll past the page hero.
    // Explicit appointment anchors still use the browser's native scrolling.
    showStep(0, false);
  });
})();